import React, { createContext, useContext, useEffect, useState } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useHistory } from 'react-router-dom';
import { generateDeepLink, parseDeepLink, getRouteFromDeepLink, DeepLinkType } from '@/services/DeepLinkService';

interface DeepLinkContextType {
  generateLink: (type: DeepLinkType, id: string, params?: Record<string, string>) => string;
  lastDeepLink: URLOpenListenerEvent | null;
}

const DeepLinkContext = createContext<DeepLinkContextType>({
  generateLink: generateDeepLink,
  lastDeepLink: null
});

const useDeepLink = () => useContext(DeepLinkContext);

export const DeepLinkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lastDeepLink, setLastDeepLink] = useState<URLOpenListenerEvent | null>(null);
  const history = useHistory();

  useEffect(() => {
    const handleDeepLink = (event: URLOpenListenerEvent) => {
      alert('Deep link opened:' + event.url);
      setLastDeepLink(event);

      const data = parseDeepLink(event.url);
      if (data) {
        const route = getRouteFromDeepLink(data);
        console.log('Navigating to deep link route:', route);
        history.push(route);
      }
    };

    // Listen for deep link events
    App.addListener('appUrlOpen', handleDeepLink);

    return () => {
      // Clean up listener when component unmounts
      App.removeAllListeners();
    };
  }, [history]);

  const value = {
    generateLink: generateDeepLink,
    lastDeepLink
  };

  return (
    <DeepLinkContext.Provider value={value}>
      {children}
    </DeepLinkContext.Provider>
  );
};
